export enum RegistrationStepsEnum {
	FirstStep = "First registration step",
	SecondStep = "Second registration step",
	RegistrationSuccessful = "Register successful",
}
